import type { AdState } from '|>/core/addons/smartlib'

import { Events } from '|>/shared/events'
import { span } from '|>/shared/h'
import { on, register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './ad-counter.css'

/**
 * Ad Counter component
 * Displays current ad number and total ads count (e.g. "Ad 1 of 4")
 */
@register
export class AdCounter extends BaseComponent {
  declare labelEl?: HTMLElement

  constructor(player, options) {
    super(player, options)
    this.hide()
  }

  override createEl() {
    const el = super.createEl()

    this.labelEl = span('.vjs-x-ad-counter-text', '')
    if (this.labelEl) {
      el.appendChild(this.labelEl)
    }

    return el
  }

  @on(Events.Media.AdStateChanged)
  handleAdStateChange(adState: AdState) {
    if (!adState.isAdPlaying || !adState.currentAd || !adState.currentAdBreak) {
      this.hide()
      return
    }

    const currentIndex = adState.currentAd.index + 1
    const totalAds = adState.currentAdBreak.adCount
    const text = this.localize('ad_current_of_amount', [
      String(currentIndex),
      String(totalAds),
    ])

    if (this.labelEl) {
      this.labelEl.textContent = text
    }

    this.show()
  }
}

AdCounter.options = {
  className: 'vjs-x-ad-counter',
}
